export class HTMLStripper {
  static strip = (htmlString: string) => {
    const div = document.createElement('div');
    let text = null;
    try {
      div.innerHTML = htmlString;
      text = div.textContent || div.innerText;
    } catch (e) {
      text = null;
    }
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    } else {
      div.style.display = 'none';
    }
    return text;
  };

  // https://stackoverflow.com/a/15459273
  static isHTML = (htmlString: string): boolean =>
    /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(
      htmlString,
    );
}
